import React from "react";
import { Button, Icon, Text } from "@chakra-ui/react";
import { FaFlask } from "react-icons/fa";

interface InsightsManagerTriggerButtonProps {
  onOpen: () => void;
}

const InsightsManagerTriggerButton: React.FC<
  InsightsManagerTriggerButtonProps
> = ({ onOpen }) => {
  return (
    <Button
      aria-label="Edit insights"
      onClick={onOpen}
      h="32px"
      maxH="32px"
      px={{ base: 2, md: 3 }}
      variant="outline"
      borderColor="var(--accent)"
      color="var(--white)"
      bg="transparent"
      _hover={{ bg: "var(--accent-08)", borderColor: "var(--accent)" }}
      transition="all 0.15s ease"
      leftIcon={<Icon as={FaFlask} color="var(--accent)" boxSize={4} />}
    >
      <Text display={{ base: "none", md: "inline" }} fontSize="13px" fontWeight="semibold">
        Edit Insights
      </Text>
    </Button>
  );
};

export default InsightsManagerTriggerButton;
